var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 443,
    viewBox: "0 0 499 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.25 0H124.75L0 221.519L124.75 443H374.25L499 221.519L374.25 0ZM325.998 357.362H172.99L96.4914 221.519L172.99 85.6629H325.998L402.509 221.519L325.998 357.362Z",
    fill: "#67CCCD",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureGreen);
export default __webpack_public_path__ + "static/media/figure_green.c8336ad73dd25a558673e0a105245ad4.svg";
export { ForwardRef as ReactComponent };